var padZero = function padZero(n) {
  return n < 10 ? "0".concat(n) : "".concat(n);
};
export var appendTimestamp = function appendTimestamp(fileName, timestamp) {
  var dotPosition = fileName.lastIndexOf('.');
  var containsDot = dotPosition > 0;
  var fileNameWithoutExtension = containsDot ? fileName.substring(0, dotPosition) : fileName;
  var extension = containsDot ? fileName.substring(dotPosition) : '';
  var date = new Date(timestamp);
  var formattedDate = "".concat(date.getUTCFullYear()).concat(padZero(date.getUTCMonth() + 1)).concat(padZero(date.getUTCDate()));
  var formattedTime = "".concat(padZero(date.getUTCHours())).concat(padZero(date.getUTCMinutes())).concat(padZero(date.getUTCSeconds()));
  return "".concat(fileNameWithoutExtension, "-").concat(formattedDate, "-").concat(formattedTime).concat(extension);
};